import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit, AfterViewInit {
  @ViewChild('testimonialContainer', { static: true }) testimonialContainer: ElementRef;

  constructor(private renderer: Renderer2) { }
  ngAfterViewInit(): void {
    this.adjustHeight();
  }

  ngOnInit() {
  }

  testimonials = [
    {
      text: 'O Grupo Globo escolheu a Empresa Union por indicação de uma pessoa de confiança, o atendimento sempre foi muito eficiente e rápido, o sistema é de fácil acesso e entendimento, atende as nossas necessidades no dia a dia, e as informações são confiáveis quanto às consultas, não tivemos até então nenhuma inconsistência de dados sobre os veículos consultados. Recentemente, implantamos um piloto do sistema integrado de avaliação e vistoria, em uma das concessionárias do grupo, o resultado tem sido satisfatório. A equipe nos atende muito bem, em qualquer dúvida e/ou esclarecimento, bem como o setor administrativo, quanto ao acerto dos serviços.',
      name: 'Jania Borges da Silva',
      description: 'Gerente Administrativo e Financeiro no Grupo Globo (Renault, Nissan e Jeep)'
    },
    {
      text: 'A Union é uma excelente empresa, tanto na prestação do serviço quanto na parceria. Não temos dificuldades com relação a comunicação e todos são bem prestativos em solucionar quaisquer problemas ou até mesmo atender solicitações "urgentes". É uma empresa que opera conosco há anos e a cada dia busca inovar no que faz, sempre atendendo nossas expectativas. Hoje trabalhamos a nível Brasil, com a vistoria cautelar, busca e apreensão e digital. Os laudos são entregues conforme prazos contratuais e sempre que imprevistos acontecem, somos informados. Nunca ficamos na mão!',
      name: 'Marina Moreira',
      description: 'Analista de Faturamento na Embracon Administradora de Consórcio Ltda'
    },
    {
      text: 'A Union sempre se mostrou uma empresa disposta a entender as necessidades da Autorola Brasil, visando sempre ofertar a melhor solução possível. A Union se destaca também, pelo excelente atendimento que presta ao seus clientes. Podemos observar uma atitude proativa dos diretores da empresa aos inspetores de campo.',
      name: 'Marcelo Barros',
      description: 'Country Manager na Autorola Brasil'
    }
  ];

  currentIndex = 0;

  goToSlide(index: number): void {

    if (index > 2) {
      index = 0;
    }
    if (index < 0) {
      index = 2
    }
    this.currentIndex = index;
    this.adjustHeight();
  }

  adjustHeight() {
    const testimonialElements = this.testimonialContainer.nativeElement.children;
    const currentTestimonial = testimonialElements[0].children[this.currentIndex] as HTMLElement;

    const height = currentTestimonial.children[0].clientHeight + currentTestimonial.children[1].clientHeight + 50;
    this.renderer.setStyle(this.testimonialContainer.nativeElement, 'height', `${height}px`);
  }


}
